import {
  Box,
  Button,
  Flex,
  Modal,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { AttachmentIcon, LinkIcon, LockIcon } from 'icons';
import { useTranslation } from 'react-i18next';

type Props = {
  opened: boolean;
  onClose: () => void;
};

const items = [
  {
    IconComponent: LinkIcon,
    title: 'listView.informationModal.sharing.title',
    description: 'listView.informationModal.sharing.description',
  },
  {
    IconComponent: AttachmentIcon,
    title: 'listView.informationModal.sharing.title',
    description: 'listView.informationModal.attachments.description',
  },
  {
    IconComponent: LockIcon,
    title: 'listView.informationModal.security.title',
    description: 'listView.informationModal.security.description',
  },
];

export const InformationModal = ({ opened, onClose }: Props) => {
  const { colors } = useMantineTheme();
  const { t } = useTranslation('forms');

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="lg"
      title={t('listView.informationModal.title')}
    >
      <Stack spacing="xl">
        <Text>{t('listView.informationModal.description')}</Text>
        <Flex direction="column" gap="lg">
          {items.map(({ IconComponent, title, description }) => (
            <Flex align="center" gap="lg">
              <Box
                sx={theme => ({
                  padding: theme.other.spacing(1),
                  background: theme.colors.gray[1],
                  borderRadius: '50%',
                })}
              >
                <IconComponent
                  size={24}
                  color={colors.gray[6]}
                  sx={{ display: 'block' }}
                />
              </Box>
              <Stack spacing="xs">
                <Text fz="md" fw={600}>
                  {t(title)}
                </Text>
                <Text fz="sm" fw={400}>
                  {t(description)}
                </Text>
              </Stack>
            </Flex>
          ))}
        </Flex>
        <Flex justify="flex-end">
          <Button variant="default" onClick={onClose}>
            {t('common:back')}
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
};
